

function ErrorMessage({msg}:{msg:string}) {
  return (
    <div className="bg-gray-300 w-full h-[50dvh] md:h-[70dvh] rounded-md text-center p-2 flex items-center justify-center">
      <h1 className="text-2xl">{msg}</h1>
      
    </div>
  )
}

export default ErrorMessage
